import { useCurrentUser } from "@/api/api-users/useCurrentUser";
import { usePlugins } from "@/hooks/usePlugins";

/**
 * Determines the default route based on plugin configuration and user permissions
 * @returns The default route path based on the plugin's configuration and user permissions.
 */
export const useMainPageRoute = () => {
  const { userIsInSuperAdminOrg } = useCurrentUser();
  const plugins = usePlugins();
  const isAnalyticsDashboardEnabled = plugins.analytics_dashboard?.show_in_navigation;

  return isAnalyticsDashboardEnabled && userIsInSuperAdminOrg ? "/app/analytics-dashboard" : "/app/accounts";
};
